function updateSize(entries) {
    for (const entry of entries) {
        if (entry.target.$resize) {
            entry.target.$resize(entry)
        }
    }
}

const resize = new ResizeObserver(updateSize)

export default {
    name: 'resize',
    wireup: {
        bind: function (target, binding) {
            target.$resize = binding.value

            resize.observe(target)
        },
        unbind: function (target) {
            if (target.$resize) {
                resize.unobserve(target)
                delete target.$resize
            }
        },
    },
}
